import * as React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export interface BackButtonProps extends React.ComponentProps<typeof Button> {
  showText?: boolean
  fallbackPath?: string
}

export function BackButton({ 
  className, 
  showText = true, 
  fallbackPath = "/",
  ...props 
}: BackButtonProps) {
  const navigate = useNavigate()
  const location = useLocation()

  // Don't show back button on home page
  if (location.pathname === "/" || location.pathname === "/dashboard") {
    return null
  }

  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      // Fallback to a specific path if no history
      navigate(fallbackPath)
    }
  }

  return (
    <Button
      variant="ghost"
      size={showText ? "sm" : "icon"}
      onClick={handleBack}
      className={cn("", className)}
      {...props}
    >
      <ArrowLeft className="h-4 w-4" />
      {showText && <span className="ml-2">Back</span>}
    </Button>
  )
}